/* #109 Cart guards: disclaimer checkbox gate, dropdown-cart remove guard, optimistic add-to-cart feedback.
   Previously three inline <script>s re-sent on every page; now one cached file loaded with defer from layout/theme.liquid. */
/* ---- from snippets/cart-disclaimer-init.liquid ---- */
(function(){
  if (window.__cartDisclaimerInited) return;
  window.__cartDisclaimerInited = true;

  var STORAGE_KEY = 'abkeys_cart_disclaimer_accepted';
  var CHECKOUT_SELECTORS = '#checkout-submit-button, .js-mobile-checkout, .js-checkout-btn';

  function isAccepted(){ try { return sessionStorage.getItem(STORAGE_KEY) === '1'; } catch(_) { return false; } }
  function setAccepted(v){ try { v ? sessionStorage.setItem(STORAGE_KEY,'1') : sessionStorage.removeItem(STORAGE_KEY); } catch(_) {} }

  function syncAll(){
    var accepted = isAccepted();
    document.querySelectorAll('[data-cart-disclaimer-checkbox]').forEach(function(cb){ cb.checked = accepted; });
    if (accepted) {
      document.querySelectorAll('[data-cart-disclaimer-block]').forEach(function(b){ b.classList.remove('is-required'); });
    }
  }

  function flagRequired(near){
    var blocks = document.querySelectorAll('[data-cart-disclaimer-block]');
    blocks.forEach(function(b){
      b.classList.add('is-required');
      b.classList.remove('is-shaking');
      // force reflow so the animation restarts on every blocked click
      void b.offsetWidth;
      b.classList.add('is-shaking');
    });
    setTimeout(function(){ blocks.forEach(function(b){ b.classList.remove('is-shaking'); }); }, 500);

    var target = null;
    if (near) {
      var ctx = near.closest('form, .dropdown-cart, .cart-summary, .cart-form_wrapper, .mobile-cart-sticky');
      if (ctx) target = ctx.querySelector('[data-cart-disclaimer-block]');
    }
    if (!target) {
      blocks.forEach(function(b){ if (!target && b.offsetParent !== null) target = b; });
    }
    if (target && target.scrollIntoView) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
  document.addEventListener('cart-change', syncAll);
  document.addEventListener('shopify:section:load', syncAll);

  document.addEventListener('change', function(e){
    var cb = e.target.closest('[data-cart-disclaimer-checkbox]');
    if (!cb) return;
    setAccepted(cb.checked);
    syncAll();
  });

  document.addEventListener('click', function(e){
    var btn = e.target.closest(CHECKOUT_SELECTORS);
    if (!btn) return;
    if (isAccepted()) return;
    e.preventDefault();
    e.stopPropagation();
    flagRequired(btn);
  }, true);
})();

/* ---- from snippets/cart-dropdown-guard.liquid ---- */
(function () {
  if (window.__cartDropdownGuardInited) return;
  window.__cartDropdownGuardInited = true;

  var CHECKOUT_SEL = '#checkout-submit-button, .js-mobile-checkout, .js-checkout-btn, button[name="checkout"]';
  var UPDATING_TEXT = 'Updating cart…';
  var BUSY_FALLBACK_MS = 3000;

  function setBusy(line) {
    document.body.setAttribute('data-cart-busy', '1');

    var clear = function () { document.body.removeAttribute('data-cart-busy'); };
    var cleared = false;
    var safeClear = function () { if (cleared) return; cleared = true; clear(); };

    var parent = line.parentNode;
    if (parent && typeof MutationObserver === 'function') {
      var obs = new MutationObserver(function () {
        if (!parent.contains(line)) { obs.disconnect(); safeClear(); }
      });
      obs.observe(parent, { childList: true });
      setTimeout(function () { try { obs.disconnect(); } catch (e) {} }, BUSY_FALLBACK_MS + 100);
    }
    setTimeout(safeClear, BUSY_FALLBACK_MS);
  }

  function recomputeAndWriteTotal(dropdown, excludedLine) {
    var sumCents = 0;
    dropdown.querySelectorAll('.js-cart-line-item').forEach(function (li) {
      if (li === excludedLine) return;
      var p = li.querySelector('.js-line-item-price');
      if (p) sumCents += +(p.dataset.linePrice || 0);
    });
    var totalText;
    try { totalText = (sumCents).toCurrency(); }
    catch (e) { totalText = null; }
    if (totalText === null) return;

    var totalEl = dropdown.querySelector('.js-cart-total');
    if (totalEl) totalEl.innerHTML = totalText;
    document.querySelectorAll('.js-cart-item-total').forEach(function (el) { el.innerHTML = totalText; });
  }

  function decrementItemCount(line) {
    var qtyEl = line.querySelector('.js-line-item-qty');
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    if (!qty || isNaN(qty)) qty = 1;
    document.querySelectorAll('.js-cart-item-count, .header-cart_count').forEach(function (el) {
      var cur = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10) || 0;
      var next = Math.max(0, cur - qty);
      el.textContent = String(next);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-btn-remove');
    if (!btn) return;
    var line = btn.closest('.js-cart-line-item');
    if (!line) return;
    var dropdown = line.closest('.js-header-dropdown-cart');
    if (!dropdown) return;
    if (line.classList.contains('is-removing-optimistic')) return;

    line.classList.add('is-removing-optimistic');
    recomputeAndWriteTotal(dropdown, line);
    decrementItemCount(line);
    setBusy(line);
  }, true);

  function flashUpdating(near) {
    var ctx = near.closest('form, .dropdown-cart, .cart-summary, .mobile-cart-sticky') || document;
    var errEl = ctx.querySelector('.js-checkout-min-error, .js-mobile-min-error');
    if (!errEl) return;
    var prevText = errEl.textContent;
    var prevDisplay = errEl.style.display;
    errEl.textContent = UPDATING_TEXT;
    errEl.style.display = 'block';
    setTimeout(function () {
      errEl.style.display = prevDisplay || 'none';
      if (prevText) errEl.textContent = prevText;
    }, 1500);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest(CHECKOUT_SEL);
    if (!btn) return;
    if (document.body.getAttribute('data-cart-busy') !== '1') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    flashUpdating(btn);
  }, true);

  document.addEventListener('cart-change', function () {
    document.body.removeAttribute('data-cart-busy');
  });
})();

/* ---- from snippets/cart-optimistic.liquid ---- */
(function () {
  if (window.__cartOptimisticInited) return;
  window.__cartOptimisticInited = true;

  var COUNT_SEL = '.js-cart-item-count, .header-cart_count';
  var BTN_SEL = '[name="add"], button[type="submit"], .js-atc-btn, .sticky-atc-btn, .js-btn-add-to-cart';
  var pending = 0, timer = null;

  function setCount(n) {
    document.querySelectorAll(COUNT_SEL).forEach(function (el) { el.textContent = String(n); });
  }
  function bump(by) {
    if (!by) return;
    document.querySelectorAll(COUNT_SEL).forEach(function (el) {
      var cur = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10);
      if (isNaN(cur)) cur = 0;
      el.textContent = String(Math.max(0, cur + by));
    });
  }
  function resyncFromServer() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && typeof c.item_count === 'number') setCount(c.item_count); })
      .catch(function () {});
  }
  function settled() {
    pending = 0;
    if (timer) { clearTimeout(timer); timer = null; }
  }
  function flashAdded(btn) {
    if (!btn) return;
    // run after the theme's own submit handler has added its spinner/pending,
    // then replace it with an instant ✓ (kept briefly, then restored).
    setTimeout(function () {
      btn.classList.remove('pending');
      btn.classList.add('cart-optimistic-added');
      clearTimeout(btn.__optTimer);
      btn.__optTimer = setTimeout(function () { btn.classList.remove('cart-optimistic-added'); }, 1800);
    }, 0);
  }

  // The authoritative cart events already update the count; cancel the safety timer.
  document.addEventListener('cart-add', settled, false);
  document.addEventListener('cart-change', settled, false);

  // Capture phase: runs before the theme's own submit handler preventDefaults + AJAXes.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    var isAdd = /\/cart\/add/.test(action) || !!form.querySelector('[name="add"]');
    if (!isAdd) return;

    var qtyInput = form.querySelector('input[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (isNaN(qty) || qty < 1) qty = 1;

    bump(qty);
    flashAdded(e.submitter || form.querySelector(BTN_SEL));

    pending++;
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { if (pending > 0) { pending = 0; resyncFromServer(); } }, 7000);
  }, true);
})();
